import BreadcrumbItem from 'Components/Atoms/BreadcrumbItem/BreadcrumbItem';
import Button from 'Components/Atoms/Button/Button';
import Container from 'Components/Atoms/Container/Container';
import { Container as ContainerDeprecated } from 'Components/Atoms/ContainerDeprecated/Container';
import Loader from 'Components/Atoms/Loader/Loader';
import Title from 'Components/Atoms/Title/Title';
import Breadcrumbs from 'Components/Molecules/Breadcrumbs/Breadcrumbs';
import ButtonGroup from 'Components/Molecules/ButtonGroup/ButtonGroup';
import DatasetNode from 'Components/Molecules/ExpandableMolecules/DatasetNode';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import FormSection from 'Components/Molecules/Form/FormSection/FormSection';
import PageHeader from 'Components/Organisms/PageHeader/PageHeader';
import Modal from 'Components/Molecules/Modals/Modal/Modal';
import ModalFooter from 'Components/Molecules/Modals/ModalFooter/ModalFooter';
import ModalHeader from 'Components/Molecules/Modals/ModalHeader/ModalHeader';
import { DatasetManagement } from 'Components/Organisms/DatasetManagement/DatasetManagement';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { ROUTE } from 'Services/Route/Route.types';
import { createDataset, fetchAllDatasets } from 'Store/FieldManagement/Actions';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { getAllDatasets } from 'Store/FieldManagement/Selectors';
import Field from '../Fields/FieldTypes/Field';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import {faPlus} from '@fortawesome/pro-solid-svg-icons';
import {useMutation} from 'react-query';
import {API_URL} from 'Store/Shared/Middleware/API/Constants';
import {getAccessTokenFromLocal} from 'Services/helpers';

const DatasetsPage = (props: any) => {
    const [isLoading, setLoading] = useState(!props.datasets[0]);
    const [createDataset, setCreateDataset] = useState(false);
    const [addDataset, setDataset] = useState('');

    useEffect(() => {
        props.fetchAllDatasets().then(() => setLoading(false));
    }, []);
    
    const saveDataset = () => {
        if (!addDataset) return;
        props.createDataset(addDataset);
        setCreateDataset(false);
    };

    const handleExportClick = async () => {
        await fetch(`${API_URL}/api/v2.9/datasets/export.csv`, {
            headers: {
                Authorization: `Bearer ${getAccessTokenFromLocal()}`
            }
        })
            .then( res => res.blob() )
            .then( blob => {
                let file = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = file;
                a.download = "datasets.csv";
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
        ;
    }

    return (
        <PageTemplate>
            <Helmet>
                <title>Datasets - Growing People B.V.</title>
            </Helmet>

            <ContainerDeprecated>
                <PageHeader
                    breadcrumbs={
                        <Breadcrumbs>
                            <BreadcrumbItem path={ROUTE.DASHBOARD}>Home</BreadcrumbItem>
                            <BreadcrumbItem path={ROUTE.SETTINGS}>Instellingen</BreadcrumbItem>
                            <BreadcrumbItem>Datasets</BreadcrumbItem>
                        </Breadcrumbs>
                    }
                />

                { isLoading && <Loader description="Datasets laden..." /> }

                {
                    !isLoading && <>
                        {
                            !props.datasets[0] && <>
                                <div>No datasets found</div>
                            </>
                        }

                        <DatasetManagement />

                        <div className={'expandable-wrapper'}>
                            {
                                props.datasets[0] && Object.keys(props.datasets).map((key: any) => {
                                    return <DatasetNode
                                            css={'rootNode'}
                                            nestedKey={-1}
                                            node={props.datasets[key]}
                                            parentId={props.datasets[key]['value']}
                                            id={props.datasets[key]['value']}
                                            key={props.datasets[key]['value']}
                                        />
                                })
                            }
                        </div>

                        <div className={'add-new'} onClick={() => setCreateDataset(true)}>+ Dataset toevoegen</div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            paddingTop: '20px',
                            paddingBottom: '80px'
                        }}>
                            <Button
                                variant='solid'
                                color='primary'
                                size='medium'
                                iconBefore={<FontAwesomeIcon icon={faPlus} />}
                                onClick={handleExportClick}
                            >
                                Exporteren naar CSV
                            </Button>
                        </div>
                    </>
                }

                {
                    createDataset &&    
                    <Modal>
                        <ModalHeader>
                            <Title size='large' weight='bold'>Voeg dataset toe</Title>
                        </ModalHeader>

                        <br/>
                        <Container>
                            <FormSection>
                                <FormGroup title='Label'>
                                    <Field
                                        type={FieldType.Text}
                                        isEdit={true}
                                        value={addDataset}
                                        onChange={(value: any) => setDataset(value)}
                                    />
                                </FormGroup>
                            </FormSection>
                        </Container>
                        <br/>

                        <ModalFooter>
                            <ButtonGroup>
                                <Button
                                    variant='transparent'
                                    onClick={() => setCreateDataset(false)}
                                >
                                    Annuleren    
                                </Button>
                                <Button
                                    color='primary'
                                    variant='solid'
                                    isDisabled={!addDataset}
                                    onClick={() => saveDataset()}
                                >
                                    Toevoegen
                                </Button>
                            </ButtonGroup>    
                        </ModalFooter>
                    </Modal>
                }
            </ContainerDeprecated>
        </PageTemplate>
    )
}

export default connect(
    (state: any) => ({
        datasets: getAllDatasets(state),
    }), {
        createDataset,
        fetchAllDatasets
    }
)(DatasetsPage)